<div #wrapper cdkTrapFocus isGlobalSearchFocused tabindex="-1" class="global-search-wrapper-desktop">
  <div #panel class="flex-container-top">
    @if (isLoading()) {
      <div class="global-search-message-panel">Searching . . . </div>
    } @else {
      @if (!hasDynamicData()) {
        <div class="global-search-message-panel">No Results Found</div>
      } @else {
        <div class="global-search-panel" (click)="handleClick($event)">
          @if (accountSearchCallState === LoadingState.Loaded && phoneNumberSearchCallState === LoadingState.Loaded) {
            <ng-container
              *ngTemplateOutlet="section; context: { $implicit: { name: 'Accounts', results: accountSearchResults } }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="section; context: { $implicit: { name: 'Phones', results: deviceSearchResults } }"
            ></ng-container>
            <ng-container
               *ngTemplateOutlet="
                  section;
                  context: { $implicit: { name: 'Phone Numbers', results: phoneNumberSearchResults } }
               "
            ></ng-container>
            <ng-container
               *ngTemplateOutlet="
                  section;
                  context: { $implicit: { name: 'SoftphoneUsernames', results: softphoneUsernameSearchResults } }
               "
            ></ng-container>
          }
        </div>
      }
    }
  </div>


</div>

<ng-template #section let-data>
  @if (data.results?.length > 0) {
    <ndt-global-search-section
      [items]="data.results"
      [sectionName]="data.name"
      [targetOpenLocations]="targetOpenLocations"
      (itemSelected)="onItemSelected()"
    ></ndt-global-search-section>
  }
</ng-template>
